/**
 * Artefact export protocol.
 *
 * The kind discriminant an evidence/agent tool run reports for a generated
 * artefact, plus the pure predicate over it that decides whether a kind can be
 * previewed inline or only downloaded.
 *
 * Frozen VERBATIM from its pre-move definition site,
 * `packages/evidence/src/ui/timeline-blocks/ArtefactBlock.tsx`, which now imports both
 * names from this door for its own use and re-exports neither: every importer
 * reads the door directly. The union order and the predicate's disjunction are
 * unchanged: the predicate is what routes a click between "open the host's
 * preview surface" and "open the URL", so a reordering is a behaviour change
 * and not a tidy-up.
 *
 * It lives in `contracts` rather than beside the component because four files
 * outside Chat need the discriminant to build an artefact payload and none of
 * them wants the renderer.
 */

export type ArtefactType =
  | 'csv'
  | 'excel'
  | 'word'
  | 'pptx'
  | 'pdf'
  | 'patient_handout'
  | 'form_fill';

/** Whether an artefact type supports inline preview (vs download-only) */
export const isPreviewableArtefactType = (type: ArtefactType): boolean =>
  type === 'pdf' ||
  type === 'patient_handout' ||
  type === 'form_fill' ||
  type === 'csv' ||
  type === 'excel' ||
  type === 'pptx';
